// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"453":"f15aa19f","455":"54f9145c","977":"821b4220"}[chunkId] + ".chunk.js";
};